import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body py-2 px-8" }
const _hoisted_5 = { class: "table align-middle table-row-dashed fs-6 gy-1" }
const _hoisted_6 = { class: "text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "UID", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

import { ref } from "vue";
import { Search } from "@element-plus/icons-vue";
import AccountOverviewService from "@/projects/tenant/views/accountOverview/services/AccountOverviewServices";
import AccountDetail from "@/projects/tenant/views/accountOverview/components/AccountDetail.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountOverviewIndex',
  setup(__props) {

const isLoading = ref(false);
const showDetail = ref(false);
const selectedAccount = ref({});
const data = ref<any>([]);
const criteria = ref({
  page: 1,
  size: 5,
  searchText: "",
});

const fetchData = async () => {
  isLoading.value = true;
  const res = await AccountOverviewService.queryAccounts(criteria.value);
  data.value = res.data;
  isLoading.value = false;
};

const handleDetail = async (item: any) => {
  showDetail.value = true;
  selectedAccount.value = item;
};

const reset = () => {
  criteria.value.searchText = "";
  showDetail.value = false;
  data.value = [];
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            modelValue: criteria.value.searchText,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.searchText) = $event)),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (fetchData()), ["enter"]))
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData()))
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            class: "ms-5",
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_6, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.email")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
              _hoisted_7,
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.user.email), 1),
                      _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                      _createElementVNode("td", null, _toDisplayString(item.uid), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (handleDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.detail")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ]),
    (showDetail.value)
      ? (_openBlock(), _createBlock(AccountDetail, {
          key: 0,
          account: selectedAccount.value
        }, null, 8, ["account"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})